<template>
  <div class="pageContainer app-container studentContainer">
    <el-row>
      <el-button size="small" @click="onAdd" plain type="primary">新增</el-button>
    </el-row>
    <el-row type="flex" :gutter="16" style="margin-top: 20px">
      <el-col :span="24" class="tabContainer">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">
            <el-table stripe :data="tableData" style="width: 100%;margin-bottom: 20px; color: #000;" border size="mini">
              <el-table-column prop="advisory_data" width="110" label="咨询日期"></el-table-column>
              <el-table-column prop="advisory_sta_data" width="110" label="咨询开始时间"></el-table-column>
              <el-table-column prop="advisory_end_data" width="110" label="咨询结束时间"></el-table-column>
              <el-table-column prop="reservation_sta_data" label="预约开始时间"></el-table-column>
              <el-table-column prop="reservation_end_data" label="预约结束时间"></el-table-column>
              <el-table-column prop="reservation_people_number" width="110" label="可预约总组数"></el-table-column>
              <el-table-column prop="reservation_people" width="110" label="已预约组数">
                <template slot-scope="scope">{{ scope.row.reservation_people || 0 }}</template>
              </el-table-column>

              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-popconfirm width="200" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info"
                    iconColor="red" @confirm="handleDel(scope.row)" placement="left" title="是否确定删除？">
                    <a slot="reference" size="small" style="color: red;font-size: 12px;margin-right: 10px;">删除</a>
                  </el-popconfirm>
                  <el-button @click="handleModify(scope.row)" type="text" size="small">修改</el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize"
              :total="page.total" @size-change="handleSizeChange" :page-sizes="page.pageSizes"
              layout="total, prev, pager, next, sizes, jumper">
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-dialog :title="modalTitle" width="600px" :visible.sync="visible" :close-on-click-modal="false"
      :destroy-on-close="true">
      <el-form :model="formData" ref="adminUserInfo" label-width="120px"
        style="max-height: 450px;overflow-y: auto;min-height: 300px;">
        <el-form-item label="咨询日期:" prop="title">
          <el-date-picker v-model="formData.advisory_data" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="咨询开始时间:" prop="title">
          <el-time-select v-model="formData.advisory_sta_data"
            :picker-options="{ start: '08:00', step: '00:30', end: '20:00' }" value-format="HH:mm" placeholder="选择时间">
          </el-time-select>
        </el-form-item>
        <el-form-item label="咨询结束时间:" prop="title">
          <el-time-select v-model="formData.advisory_end_data"
            :picker-options="{ start: '08:00', step: '00:30', end: '20:00' }" value-format="HH:mm" placeholder="选择时间">
          </el-time-select>
        </el-form-item>

        <el-form-item label="预约开始时间:" prop="title">
          <el-date-picker v-model="formData.reservation_sta_data" type="datetime" placeholder="选择日期时间"
            default-time="09:00:00" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>

        </el-form-item>
        <el-form-item label="预约结束时间:" prop="title">
          <el-date-picker v-model="formData.reservation_end_data" type="datetime" placeholder="选择日期时间"
            default-time="00:00:00" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="可预约组数:" prop="sort">
          <el-input-number v-model="formData.reservation_people_number" controls-position="right" :min="0">
          </el-input-number>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="formData.sort" controls-position="right"></el-input-number>

        </el-form-item>
        <el-form-item label="已预约人数:" prop="sort">{{ formData.reservation_people || 0 }}</el-form-item>


      </el-form>
      <el-row>
        <el-col :span="22" style="text-align: right;">
          <el-button size="small" type="default" @click="visible = false">取消</el-button>
          <el-button size="small" type="primary" @click="saveForm('adminUserInfo')">保存</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/api/api';

export default {
  name: 'Student',
  components: {

  },
  data() {
    return {
      tabMapOptions: [{
        label: '家长预约',
        key: 'notsp'
      }],
      activeName: 'notsp',

      modalTitle: '添加',
      visible: false,
      formData: {},
      tableData: [],
      page: {
        pageIndex: 1,
        pageSize: 20,
        pageSizes: [10, 20, 50],
        total: 0
      },

      pmid: 1,
    }
  },
  watch: {
    activeName(val) {
      this.$router.push(`${this.$route.path}?tab=${val}`)
    }
  },
  created() {
    // init the default selected tab
    const tab = this.$route.query.tab
    if (tab) {
      this.activeName = tab
    }
  },
  mounted() {
    this.getList();

    this.$nextTick(() => {
      $("#btnxlsbox").width($(window).width() - 500)
    })

    if (sessionStorage.getItem('userinfo')) {
      let userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
      console.log(userinfo.pmid)
      this.pmid = (userinfo && userinfo.pmid) ? userinfo.pmid : this.pmid
    }

  },
  methods: {
    getList() {
      this.tableData = []
      let params = {
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
      }
      this.$http.post('/api/reservation_time_list', params).then(res => {
        this.tableData = res.data.data
        this.page.total = res.data.page.count
      })
    },
    onAdd() {
      this.modalTitle = '新增'
      if (this.formData.advisory_data) {
        this.formData.id = 0
      } else {
        this.formData = {}
      }

      this.visible = true
    },
    handleModify(row) {
      this.modalTitle = '修改';
      this.formData = row
      this.visible = true
    },
    handleDel(row) {
      this.$http.post('/api/reservation_time_delete', {
        id: row.id
      }).then(res => {
        this.$message.success('删除成功')
        this.getList();
      })
    },
    handlePageChange(e) {
      this.page.pageIndex = e
      this.getList()
    },
    handleSizeChange(e) {
      this.page.pageSize = e
      this.getList()
    },

    saveForm() {
      let _this = this
      let params = Object.assign(_this.formData)
      this.$http.post('/api/reservation_time_edit', params).then(res => {
        this.$message.success('保存成功')
        this.visible = false
        this.getList();
      })
    },




    downTableAll() {

    },
    downTable1() {

    },
    downTable2() {

    },
  }
}
</script>

<style lang="less" type="text/less">
.studentContainer {
  .el-tabs__nav {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .el-tabs__item {
    line-height: unset;
    display: flex;
    align-items: center;
  }

  .el-tabs__item.is-disabled {
    color: #303133;
    cursor: default
  }

  .el-tabs__item.is-active {
    color: #409EFF;
  }
}
</style>
<style scoped lang="less" type="text/less">
.app-container {
  .treeContainer {
    height: 100%;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
    border: 1px solid rgba(220, 223, 230, 0.6);

    .treeTitle {
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #409eff;
      padding-left: 6px;
    }
  }
}
</style>
